"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.23 5.52a1 1 0 011.62 1.16l-.08.11-9.93 12.07a1 1 0 01-1.33.19l-.1-.05-6.07-5.38A1 1 0 014.56 12l.1.08L10 16.79z"
  });
}.bind(void 0));

exports.default = _default;